import { useEffect } from 'react';

import { GigyaAPI } from '@ciam/gigya-api';
import { useLoginStore } from '@features/shared';
import { useValidatorStore } from '@features/proxy';

import type { UserInfo } from '@features/shared';

export const LoginInfoCheck = () => {
  const { setCurrentUser } = useLoginStore();

  const { setValidateStep } = useValidatorStore();

  useEffect(() => {
    const fetchAccountInfo = async () => {
      try {
        // [STEP 1] 로그인 된 계정 정보 가져오기
        const accountInfo = (await GigyaAPI.accounts.getAccountInfo()) as UserInfo;
        const isAdLogin = accountInfo.socialProviders?.split(',').includes('saml-samsung-ad') || false;

        await setCurrentUser({
          ...accountInfo,
          email: accountInfo.profile?.email ?? '',
          uid: accountInfo.UID ?? '',
          uidSignature: accountInfo.UIDSignature ?? '',
          isAdLogin: isAdLogin,
        });

        return setValidateStep('mfa-check');
      } catch (err) {
        console.error('Failed to fetch account info:', err);
      }
    };

    fetchAccountInfo();
  }, [setCurrentUser, setValidateStep]);

  return null;
};
